import {Injectable} from '@angular/core';
import {Capacitor} from '@capacitor/core';
import {from, Observable, of, tap} from 'rxjs';
import {NumberSeparators} from 'src/app/domain/number-separators';
import NumberFormat from 'src/app/localPlugins/number-format-plugin';

@Injectable({
  providedIn: 'root'
})
export class NumberFormatService {
  numberSeparators: NumberSeparators;
  ready$: Observable<NumberSeparators>;

  constructor() {
    if (Capacitor.getPlatform() === 'ios') {
      this.ready$ = from(NumberFormat.getNumberFormat()).pipe(
        tap(separators => this.numberSeparators = separators)
      );
    } else {
      const numberSeparators: NumberSeparators = {
        decimalSeparator: '.',
        groupSeparator: ','
      };
      this.numberSeparators = numberSeparators;
      this.ready$ = of(numberSeparators);
    }
  }
}
